// Versión de `features/niko/strings` para las builds que NO incluyen la funcionalidad.
//
// El Dockerfile la copia sobre `strings.js` cuando se construye la imagen core (ver ARG
// NIKO_ENABLED). Se reemplaza en vez de borrarse porque `utils/translation.js` la
// importa de forma estática: sin el archivo, el build del core no resuelve.
//
// Sin textos que fusionar, el diccionario del idioma queda sin la sección de Niko.
export const nikoStrings = { es: {}, en: {} };
